






































































import { Component, Vue } from "vue-property-decorator";
import UserApi from "@/api/userApi";
import { namespace } from "vuex-class";
import { ADMIN_TYPE, CUSTOMER_TYPE } from "@/common/constant";
import AdminUser from "@/model/adminUser";
import CustomerUser, { CUSTOMER_AUTHORITY } from "@/model/customerUser";
import ForgotPassword from "@/views/pages/forgotPassword.vue";
import ChangeUserInfo from "@/views/pages/changeUserInfo.vue";
import SettingApi from "@/api/settingApi";

const auth = namespace("Auth");
@Component({
  name: "LoginPage",
  components: {
    ForgotPassword,
    ChangeUserInfo,
  },
})
export default class LoginPage extends Vue {
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateAuthenticateStatus!: (token: string) => void;
  @auth.Action
  updateExpiredAt!: (time: string) => void;
  @auth.Action
  updateUserType!: (userType: string) => void;
  @auth.Action
  fetchCurrentUser!: (user: any) => void;
  @auth.Action
  updateIsLoginTime!: (isLoginTime: boolean) => void;

  @auth.Getter
  getAdminUser!: AdminUser;
  @auth.Getter
  getCustomerUser!: CustomerUser;

  loginInfo = {
    login_id: "",
    password: "",
  };
  errorMessage = "";

  news = "";
  maintenanceNotice = "";

  async mounted() {
    const loader = Vue.$loading.show({});
    const requests: any = [
      SettingApi.getNews(),
      SettingApi.getMaintenanceNotice(),
    ];
    const result: any = await Promise.all(requests);
    loader.hide();
    result[0] && (this.news = result[0].data.data);
    result[1] && (this.maintenanceNotice = result[1].data.data);
    // await SettingApi.getNews()
  }
  replaceWithBr(text) {
    return text.replace(/\n/g, "<br />")
  }
  async login(): Promise<void> {
    try {
      this.errorMessage = "";

      if (this.loginInfo.login_id == '' && this.loginInfo.password == '') {
        this.errorMessage = `${this.$t("login.required.login_id_and_password")}`;
        return;
      } else if (this.loginInfo.login_id == '') {
        this.errorMessage = `${this.$t("login.required.login_id")}`;
        return;
      } else if (this.loginInfo.password == '') {
        this.errorMessage = `${this.$t("login.required.password")}`;
        return;
      }

      const result = await UserApi.login(this.loginInfo);

      if (result.data.meta.status == 200) {
        this.updateToken(result.data.meta.token);
        this.updateUserType(result.data.data.user_type);
        this.updateIsLoginTime(true);
        await this.fetchCurrentUser(result.data.data.user_info);
        console.log(result);
        if (result.data.data.user_type === ADMIN_TYPE) {
          this.$router.push({ name: "admin.default" });
        } else if (result.data.data.user_type === CUSTOMER_TYPE) {
          if (
            result.data.data.user_info.account_authority ==
            CUSTOMER_AUTHORITY.ADMIN_CUSTOMER
          ) {
            this.$router.push({ name: "admin-customer.default" });
          } else {
            this.$router.push({ name: "front.home" });
          }
        }
      } else {
        this.errorMessage = result.data.meta.message;
      }
    } catch (error) {
      if (error.response) {
        this.errorMessage = error.response.data.meta.message;
      } else {
        console.log(error);
      }
    }
  }

  public forgotPassword() {
    (this.$refs.forgotPassword as ForgotPassword).show();
  }
}
